// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".help-how-it-works[data-v-bda7cf14] {\n  flex-basis: 0;\n  flex-grow: 0.4;\n}", ""]);
// Exports
module.exports = exports;
